import type { Symbol } from './instruments';
import type { Timeframe } from './zone-math';
import { loadDerivCandles } from './deriv-feed.js';
import { loadHeadwayCandles } from './headway-feed.js';
import { loadVantageCandles } from './vantage-feed.js';

// Prefer the direct public feed; the same-provider HTTP route also recovers
// failed browser sockets. Never substitute another broker's candle prices.
export async function marketCandles(symbol: Symbol, timeframe: Timeframe, signal: AbortSignal) {
  if (symbol === 'VOL40') return loadVantageCandles(symbol, timeframe, { signal });
  if (symbol === 'VOL80') return loadHeadwayCandles(symbol, timeframe, { signal });
  if (typeof window.WebSocket === 'function') {
    try {
      if (signal.aborted) throw new DOMException('Aborted', 'AbortError');
      const value = await loadDerivCandles(symbol, timeframe, { signal });
      if (signal.aborted) throw new DOMException('Aborted', 'AbortError');
      return value;
    } catch (error) {
      if (signal.aborted || (error instanceof Error && error.name === 'AbortError') || symbol === 'WTI') throw error;
    }
  }
  const response = await fetch('/api/zone-candles?symbol=' + symbol + '&tf=' + timeframe, { signal });
  if (!response.ok) {
    const problem = await response.json().catch(() => null);
    throw new Error(typeof problem?.error === 'string' ? problem.error : 'Market data is temporarily unavailable. Retrying automatically.');
  }
  return response.json();
}
